import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Layout, Menu} from "antd";
import {Content} from "antd/es/layout/layout";
import CommonHeader from "../../components/common-header";
import Sider from "antd/es/layout/Sider";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import styled from "styled-components";
import { useStore } from "../../store";

function getItem(
    label: string,
    key?: React.Key | null,
    icon?: React.ReactNode,
    children?: any[],
    type?: 'group',

) {
    return {
        label,
        key,
        icon,
        children,
        type,
    } ;
}

const Manager: React.FC = () => {
    const {loginStore} = useStore();
    const [items, setItems] = useState<any[]>([]);

    const navigateTo = useNavigate();
    const location = useLocation();
    let initSelect:string=''
    const [openKeys, setOpenKeys] = useState([initSelect]);
    const onMenuSelect = (info:any) => {
        navigateTo(info.key);
    }
    const rootSubmenuKeys = ['database', 'article', 'permissions'];
    const handleOpen=(keys:string[])=> {
        // 这是antd官方的写法
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    }
    // 刷新时被选中的menu二级菜单初始化的展开问题
    useEffect(()=> {
        fillMenuList();
        const refreshThePage = () => {
            //  pathname:  /page3/page301    rank: ['', 'page3', 'page301']
            // 判断是几级菜单，二级菜单rank.length为3
            let rank=location.pathname.split('/')
            //  pathname:  /page3/page301    rank: ['', 'page3', 'page301']
            // 判断是几级菜单，二级菜单rank.length为3
            if(rank.length===4){
                let newOpenkeys=rank.slice(2,3).join('/') // newOpenkeys: /page3
                setOpenKeys([newOpenkeys])
            }
        }
        refreshThePage()
    },[]);

    const fillMenuList = () => {
        const items = [
            findMenuByKey("/manager/Dashboard") ? getItem("数据统计", "/manager/Dashboard") : null,
            findMenuByKey("database") ? getItem("数据库管理", "database",null,[
                findMenuByKey("/manager/database/basic-library") ? getItem("基础库维护", "/manager/database/basic-library") : null,
                findMenuByKey("/manager/database/specimen") ? getItem("植物标本", "/manager/database/specimen") : null,
                findMenuByKey("/manager/database/picture") ? getItem("原植物图库", "/manager/database/picture") : null,
                findMenuByKey("/manager/database/image-library") ? getItem("图谱库", "/manager/database/image-library") : null,
                findMenuByKey("/manager/database/dna-library") ? getItem("DNA序列库", "/manager/database/dna-library") : null,
            ]) : null,
            findMenuByKey("article") ? getItem("文章管理", "article",null,[
                findMenuByKey("/manager/science") ? getItem("科普宣传", "/manager/science") : null,
            ]) : null,
            findMenuByKey("permissions") ? getItem("权限管理", "permissions",null,[
                findMenuByKey("/manager/permissions/user") ? getItem("用户管理", "/manager/permissions/user") : null,
                // getItem("功能管理", "function"),
                // getItem("角色管理", "role"),
            ]) : null,
            findMenuByKey("system") ? getItem("系统设置", "system",null,[
                findMenuByKey("/manager/system/web-setting") ? getItem("网站设置", "/manager/system/web-setting") : null,
                findMenuByKey("/manager/system/about-us") ? getItem("关于我们", "/manager/system/about-us") : null,
            ]) : null,
        ];
        setItems(items)
    }

    const findMenuByKey = (key:string) => {
        const menuStr =  localStorage.getItem("menuList")
        const list = JSON.parse(menuStr === null ? "" : menuStr);
        if (key === "/manager/permissions/user"){
            console.log("dtl----", list.findIndex((item:any) => (item.router === key)))
        }
        if (list instanceof  Array) {
            const index = list.findIndex((item:any) => (item.router === key))
            return index !== -1
        }
        return false
    }

    return (
        <Wrapper>
            <CommonHeader isLogin={true} userName={loginStore.userInfo?.username}/>
            <Line/>
            <Layout>
                <Sider theme={"light"} collapsible={false} width={"238px"}
                       style={{background: "#ffffff", marginTop: "1px"}}>
                    <Menu
                        theme={"light"}
                        mode={"inline"}
                        items={items}
                        defaultSelectedKeys={[location.pathname]}
                        onOpenChange={handleOpen}
                        openKeys={openKeys}
                        onSelect={onMenuSelect}
                    />
                </Sider>
                <Layout style={{flex:1, overflow: 'hidden'}}>
                    <Content style={{ height: '100%', display: 'flex', overflow: 'hidden' }}>
                        <Outlet/>
                    </Content>
                </Layout>
            </Layout>
        </Wrapper>

    );
}

export default observer(Manager);
const Wrapper = styled.div`
  & {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: white;
    overflow: hidden;

    .ant-menu-item-selected {
      background: #1990FF !important;
      color: white;
    }
    .ant-menu-light .ant-menu-item:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected), :where(.css-dev-only-do-not-override-26rdvq).ant-menu-light .ant-menu-submenu-title:hover:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected){
      background-color: #E5F3FF !important;
    }
    .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-submenu-title:hover{
      background-color: #E5F3FF !important;
    }
  }
`;
const Line = styled.div`
  & {
    height: 1px;
    border-bottom: 1px solid #EAEDF7;
  }
`;
